<template>
  <div class="legal-notices">
    <StaticPagesHeader class="header"></StaticPagesHeader>
    <div class="container">
      <h1 class="title">{{ $t(`legalNotices.title`) }}</h1>
      <InternalStaticNav v-bind:links="links" />
      <div class="columns">
        <div class="left-column">
          <div
            v-for="(section, index) in sections"
            :key="index"
            v-bind:id="section.key"
          >
            <StyledParagraph
              v-bind:title="section.title"
              v-bind:paragraphs="section.paragraphs"
            />
          </div>
        </div>
        <MenuFixed v-bind:links="links" />
      </div>
    </div>
  </div>
</template>

<script>
import StaticPagesHeader from "@/components/staticpages/StaticPagesHeader";
import StyledParagraph from "@/components/staticpages/StyledParagraph";
import MenuFixed from "@/components/staticpages/MenuFixed";
import i18n from "@/i18n";

export default {
  name: "LegalNotices",
  components: {
    StaticPagesHeader,
    StyledParagraph,
    MenuFixed,
  },
  computed: {
    sections: function () {
      const section_titles = Object.keys(
        i18n.global.getLocaleMessage(this.$i18n.locale).legalNotices,
      ).slice(1); // first key is the page's title
      const sects = section_titles.map((section) => {
        var obj = {
          title: i18n.global.getLocaleMessage(this.$i18n.locale).legalNotices[
            section
          ].title,
          paragraphs: i18n.global.getLocaleMessage(this.$i18n.locale)
            .legalNotices[section].paragraphs,
          key: section,
        };
        return obj;
      });
      return sects;
    },
    links: function () {
      return this.sections
        .filter((section) => (section.key ? true : false))
        .map((section) => {
          return { name: section.title, ref: section.key };
        });
    },
  },
};
</script>

<style scoped lang="scss">
.legal-notices {
  .title {
    text-align: center;
    font-family: "Averia Sans Libre", sans-serif;
    font-size: 3em;
    color: $primaryColor;
    margin: 40px 0 40px 0px;
  }
}

.columns {
  display: flex;

  .left-column {
    width: 60%;
  }
}

@media only screen and (max-width: 792px) {
  .columns {
    .left-column {
      width: 100%;
    }
  }
}
</style>
